<template>
    <!-- Gleicher Rahmen wie die Nachbar-Box (Ausstehende Freigaben), damit die
         beiden Blöcke auf der Übersicht als Paar wirken — wie in der
         Betreuer-Ansicht. -->
    <div
        class="border border-4 border-minplan-beige p-2 md:p-6 mt-6 w-full flex flex-col"
    >
        <div class="flex items-baseline justify-between gap-3">
            <h2 class="font-bold uppercase tracking-wider">
                {{ $t("apartments.notes") }}
            </h2>
            <Link
                v-if="entries.length > 3"
                :href="notesLink"
                class="text-xs text-minplan-darkbeige hover:text-minplan-blue"
            >
                {{ $t("apartments.showAllNotes") }} ({{ entries.length }}) &rarr;
            </Link>
        </div>

        <!-- Anriss: die drei neuesten Einträge. Kein Kennzeichen «für Käufer»
             und keine Schaltfläche «Neuer Eintrag» — hier ist ohnehin nur
             Freigegebenes, und Anlegen ist Betreuer-Bedienung. Genau deshalb
             ist das eine eigene Komponente und nicht `ApartmentsNotes.vue`:
             dort hängt der Anlege-Knopf an `notesLink`. -->
        <div class="mt-4 divide-y divide-minplan-lightwhite">
            <Link
                v-for="entry in entries.slice(0, 3)"
                :key="entry.uuid"
                :href="notesLink"
                class="flex items-center justify-between gap-4 py-2.5 px-2 -mx-2 hover:bg-minplan-lightwhite"
            >
                <span class="flex items-center gap-2 min-w-0">
                    <component
                        :is="iconFor(entry.category)"
                        class="h-4 w-4 shrink-0 text-minplan-darkbeige"
                    />
                    <span class="text-sm text-minplan-blue truncate">{{
                        entry.title
                    }}</span>
                </span>
                <span class="text-xs text-minplan-darkbeige whitespace-nowrap">
                    {{ entry.dateFormatted }}
                </span>
            </Link>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { Link } from "@inertiajs/inertia-vue3";
import { noteIconFor } from "@/Shared/noteIcons";

/**
 * Der Anriss der freigegebenen Notizen auf der Wohnungs-Übersicht des Käufers
 * (Auftrag Luca, 2026-08-17, Entscheid 3).
 *
 * Die Komponente kennt keinen Leerfall: sie wird nur gerendert, wenn der
 * Server `notesLink` liefert, und das tut er nur bei mindestens einer
 * freigegebenen Notiz (Entscheid 7). Ein Block mit «Keine Notiz vorhanden»
 * war genau der Grund, warum der Notizen-Block in Welle 4 aus der
 * Käuferansicht wieder verschwunden ist.
 */
export default defineComponent({
    props: ["notes", "notesLink"],
    components: {
        Link,
    },
    computed: {
        entries() {
            return this.notes || [];
        },
    },
    methods: {
        iconFor(category) {
            return noteIconFor(category);
        },
    },
});
</script>

<style scoped></style>
